fx.ns("desktop.book.edition", class SmallView extends shared.stage.BaseView {

    constructor(board){
        super(board);

        this.vmargin = 100;
        this.spaceAfterPage = 80;
    }

    /*get numberElementsPerLine()
    {
        return 4;
    }*/


    // let display page 4 per 4
    update(animate) 
    {
        //this.scale = Math.max(0.1, 500 / fx.graphics.screenSize().width);
        //let numberElementsPerLine = Math.max(1,Math.floor(1 / this.scale));

        let sideMargin = 25;
        let screenWidth = (this.board.realWidth - 2*sideMargin - 120); // 100 == topbar | TODO : get TopBar reference
        let childWidth = 250;
        let actionWidth = 60;
        
        let numberElementsPerLine =  Math.floor( screenWidth / (childWidth + actionWidth) );
        
        while(numberElementsPerLine < 2)
        {
            childWidth -= 10;
            numberElementsPerLine =  Math.floor( screenWidth / (childWidth + actionWidth) );
        }

        let marginOffset = (screenWidth - (numberElementsPerLine * (childWidth + actionWidth))) / 2;

        
        let childs = this.board.allChilds;

        let numElementOnCurrentline = 1, 
            childXPos = 0, 
            childYPos = 0, 
            yPos = this.vmargin, 
            childScale = 1, previousPage;

        for (let i = 0; i < childs.length; i++) 
        {
            let child = childs[i];
            
            child.show();

            if (child instanceof shared.stage.Area)
            {
                childScale = childWidth / child.width();

                if (child.data.isCover)
                {
                        childXPos = (screenWidth - child.realWidth*childScale)/2 / childScale;
                        childYPos =  yPos / childScale;
                        yPos += child.realHeight *  childScale  +this.spaceAfterPage;
                }
                else
                {
                    if (numElementOnCurrentline > numberElementsPerLine)
                    {
                        numElementOnCurrentline = 1;
                        yPos += child.realHeight *  childScale  +this.spaceAfterPage;
                    }

                    childXPos = sideMargin/ childScale + marginOffset/ childScale + ( (numElementOnCurrentline-1) * (child.realWidth + actionWidth/ childScale));
                    childYPos = yPos / childScale;
                    previousPage = child;
                }
               
                child.addClass("movable");
            }   
            else // addPage
            {
                if (typeof child.vertical == "function")
                    child.vertical(actionWidth, previousPage.realHeight*childScale);

                childXPos = (childXPos + previousPage.realWidth)* childScale ;
                childYPos = yPos;
                childScale = 1;
                
                numElementOnCurrentline++;

            }
                

            this.applyPosition(child, { scale : childScale, x : childXPos, y :  childYPos }, (child instanceof shared.stage.Area));
        }

        this.delay(this.scroll, animate ? 250 : 0);
    }

    select(area, animate)
    {
        // no need to select a view here
    }

    scroll()
    {
        let viewPort = { top : this.board.scrollPosition, bottom : this.board.scrollPosition  + this.board.realHeight };
        this._areas = [];

        for (let i = 0; i < this.board._editableAreas.length; i++)
        {
            let area = this.board._editableAreas[i];

            // TODO : check if still needed
            if (area.dragActive)
                continue;

            let position = this.getPosition( area );
            
            if (!position)
                continue;
                
            let load = !( position.y*position.scale  > viewPort.bottom  || (position.y*position.scale + fx.dom.height(area.node) * position.scale) < viewPort.top );
            this._areas.push({area : area, load : load});

        }

        this.delay(this._loadUnload, 50);
        
        //let activeArea;

        // let's find the most visible and set it active
        /*for (let i = 0; i < loadedAreas.length; i++)
        {
            let area = loadedAreas[i];
            if (!activeArea || activeArea.visibleSurface < area.visibleSurface)
                activeArea = area;
        }*/

        /*if (activeArea != this.board.currentArea)
        this.board.currentArea = activeArea;*/
    }

    _loadUnload()
    {
        for (let i = 0; i < this._areas.length; i++)
        {
            let item = this._areas.getItemAt(i);
            if (item.load)
                item.area.load();
            else
                item.area.unload();
        }

    }

});
